export default __webpack_public_path__ + "static/media/unrated-star.b1854009.svg";